import React, { Component, PropTypes } from 'react';
import Reflux from 'reflux';
import {
  AppBar,
  Paper,
  Styles,
  FontIcon,
  TextField,
  IconButton,
  FlatButton
} from 'material-ui';
import EventManager from 'services/EventManager';
import AppActions from 'actions/App';
import { AuthStore, NotificationStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
// import ReactGestures from 'react-gestures';

import { Colors, Units } from 'Css';

const css = oxygenCss({
  root: {
    position: 'fixed',
    top: 0
  },
  count: {
    position: 'absolute',
    left: Units.base,
    top: Units.base,
    width: 24,
    borderRadius: '50%',
    boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px',
    backgroundColor: Colors.material.red[500].hex,
    color: Colors.text.Light.default,
    fontSize: 12,
    lineHeight: '24px',
    textAlign: 'center',
    cursor: 'pointer'
  },
  header: {
    fontSize: '24px',
    margin: 0,
    fontWeight: 100,
    lineHeight: `${Units.base * 6}px`,
    color: Colors.fullWhite
  }
});

export default class RulerBar extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    title: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node
  };

  listenToStores() {
    this.listenToStore(AuthStore);
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));
    this.listenToStoreWithMapper(NotificationStore, state => ({
      unreadNotifications: state.unreadNotifications
    }));
  }

  toggleAppBar = event => {
    AppActions.toggleAppBar();
    event.preventDefault();
  };

  onSearchTextChange = () => {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      let searchText = null;
      const fieldValue = this.refs.searchField.getValue();
      if (fieldValue !== '') {
        searchText = fieldValue.toUpperCase();
      }
      AppActions.search(searchText);
    }, 500);
  };

  render() {
    const { children, ...other } = this.props;
    const { loggedIn, unreadNotifications } = this.state;
    const hasCount = !!unreadNotifications;
    if (loggedIn) {
      return (
        <AppBar
          className={css.root}
          onLeftIconButtonTouchTap={this.toggleAppBar}
          title={<div className={css.header}>{this.props.title}</div>}
          zDepth={0}
          style={{ zIndex: 6 }}
          {...other}
        >
          {hasCount && (
            <div className={css.count} onTouchTap={this.toggleAppBar}>
              {unreadNotifications < 100 ? unreadNotifications :  '10+'}
            </div>
          )}
          {children}
        </AppBar>
      );
    }
    return (
      <AppBar
        showMenuIconButton={false}
        className={css.root}
        title={<div className={css.header}>{this.props.title}</div>}
        zDepth={0}
        {...other}
      >
        {children}
      </AppBar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/RulerBar.js